import moment from 'moment';
import request from 'superagent';
import storage from 'utils/storage';
import * as R from 'ramda/src/index';
import {saveQuery} from 'providers/storage';
import {validateQuery} from './validator';
import {isProduction, environment, localeFull, isoCurrency} from 'helpers/stableValues';
import {getPortCode, cacheKey, createUrlParams} from 'ferries/helpers/common';
import {
  today,
  defaultDateOrDate,
  dateIsSameOrAfterToday,
  obDateIsSameOrAfterTodayAndIbDateIsAfterObDate
} from 'helpers/time';
import {datePattern, languageFromUrl} from 'helpers/commonHelper';
import {bookingBaseUrl} from 'helpers/stableValues';
import {getPortsBilingual} from './autocompleteResultsBasedOnTypedLanguage/api';
import {isUserLocaleGreekOrEnglish} from './autocompleteResultsBasedOnTypedLanguage/utils';
import {domain} from 'ferries/helpers/common';

const cache = storage.createStore({name: 'portsCache'});

const buildFerryUrl = (query) => (
  validateQuery(query)
    .then(({typeTrip, trips}) => {
      const newQuery = {
        typeTrip,
        trips: trips.map(({dep, arr, obDate, ibDate}) => ({
          departure: dep,
          arrival: arr,
          obDate: moment(obDate).format('YYYY-MM-DD'),
          ibDate: moment(ibDate).format('YYYY-MM-DD')
        }))
      };

      const queryFerryResults = {
        dep: trips.map(({dep}) => getPortCode(dep)),
        arr: trips.map(({arr}) => getPortCode(arr)),
        date: trips.map(({obDate}) => moment(obDate))
      };

      saveQuery(newQuery, cacheKey);

      return `${languageFromUrl()}/${bookingBaseUrl}/results${createUrlParams()}` +
        `${createHash(queryFerryResults)}`;
    })
);

const createHash = (query) => (
  ['dep', 'arr', 'date']
    .reduce((accumulator, key) => {
      accumulator += '/' + key + '/';
      const value = query[key];
      if (key === 'date') {
        accumulator += value.map((date) => date.format('YYYY-MM-DD')).join(',');
      } else if (key === 'dep' || key === 'arr') {
        accumulator += value.join(',');
      } else {
        accumulator += value;
      }
      return accumulator;
    }, '#search')
);

const transformQuery = ({dep, arr, typeTrip, obDate, ibDate}) => {
  const initObDate = moment(today).add(1, 'days');
  const initIbDate = moment(today).add(3, 'days');
  obDate = datePattern.test(obDate) ?
    (dateIsSameOrAfterToday(moment(obDate)) ? moment(obDate) : initObDate) :
    initObDate;
  if (datePattern.test(ibDate)) {
    if (obDateIsSameOrAfterTodayAndIbDateIsAfterObDate(obDate, moment(ibDate))) {
      ibDate = moment(ibDate);
    } else {
      ibDate = defaultDateOrDate(obDate, initIbDate);
    }
  } else {
    ibDate = defaultDateOrDate(obDate, initIbDate);
  }

  return {
    dep: dep && dep.length === 3 ? dep : '',
    arr: arr && arr.length === 3 ? arr : '',
    typeTrip,
    obDate,
    ibDate
  };
};

const transformQueryVal = (type, value) => {
  switch (type) {
  case 'dep':
  case 'arr':
    value = value.split(',');
    break;
  case 'date':
    value = value.split(',').map((item) => datePattern.test(item) ? moment(item) : '');
    break;
  }

  return value;
};

const autocompletePorts = ({preferredLocale, preferredCurrency}) => (
  request
    .get(`${domain}/api/v1/ferries/autocomplete/fallback`).set('x-override-header', 'ferryscanner-web')
    .query({preferredLocale, preferredCurrency})
);

const portsCaching = ({preferredLocale, preferredCurrency}) => {
  if (!isProduction && environment !== 'staging') {
    return cache.getItem(preferredLocale).then((value) => {
      if (value && value.length) {
        return value;
      }

      return autocompletePorts({preferredLocale, preferredCurrency})
        .then(({body}) => {
          const {results} = body;
          cache.setItem(preferredLocale, results);
          return results;
        });
    });
  }
  return autocompletePorts({preferredLocale, preferredCurrency})
    .then(({body}) => body.results);
};

const getPorts = ({isBilingual = false} = {}) => {

  if (isUserLocaleGreekOrEnglish() && isBilingual) {
    return getPortsBilingual();
  }

  return portsCaching({preferredLocale: localeFull, preferredCurrency: isoCurrency()})
    .then(R.identity)
    .catch(() => {

    });
};

export {buildFerryUrl, createHash, transformQuery, transformQueryVal, getPorts};
